export const ENABLED_TABINDEX_FOR_NON_INPUT = 0;
export const ENTER_KEY = 'Enter';
